var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: { title: _vm.title, loading: _vm.loading, width: _vm.width },
          on: { "on-ok": _vm.uploadImg, "on-cancel": _vm.close },
          model: {
            value: _vm.modal1,
            callback: function($$v) {
              _vm.modal1 = $$v
            },
            expression: "modal1"
          }
        },
        [
          _vm._t("default", function() {
            return [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-around",
                    "align-items": "center"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "cropper", style: _vm.originStyle },
                    [_c("img", { ref: "cropperImg", attrs: { alt: "" } })]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: { "text-align": "center", margin: "15px 0" }
                    },
                    [
                      _c("Icon", {
                        attrs: { size: "30", type: "md-arrow-forward" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "preview-area" }, [
                    _c("div", {
                      class: _vm.options.preview.slice(1),
                      style: _vm.previewStyle
                    })
                  ])
                ]
              )
            ]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55b50a9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55b50a9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cropper_img.vue
// module id = null
// module chunks = 